<template>
  <div
    ref="rootRef"
    class="inline-flex h-10 items-stretch rounded-md border border-gray-300 bg-white shadow-sm"
    role="group"
    aria-label="Share"
  >
    <VButton
      type="button"
      variant="copper-borderless"
      class="!flex-row !justify-center header-button !rounded-none !rounded-l-md !border-0 !shadow-none min-w-[7rem] px-3 gap-2 h-full !normal-case"
      no-shadow="noShadow"
      @click="emit('open-share')"
    >
      <FontAwesomeIcon icon="share-nodes" class="w-4 h-4 shrink-0" />
      <span class="ml-2 text-sm">Share</span>
    </VButton>

    <div class="w-px bg-gray-300 shrink-0 self-stretch" aria-hidden="true" />

    <div class="relative flex">
      <VButton
        type="button"
        variant="copper-borderless"
        class="header-button !rounded-none !rounded-r-md !border-0 !shadow-none px-2 h-full min-w-[2.25rem]"
        no-shadow="noShadow"
        aria-label="More share options"
        @click="menuOpen = !menuOpen"
      >
        <ChevronDownIcon class="w-4 h-4 shrink-0 text-gray-700" />
      </VButton>

      <div
        v-show="menuOpen"
        class="absolute right-0 top-full z-50 mt-1 w-72 rounded-lg border border-gray-200 bg-white py-1 shadow-lg ring-1 ring-black/5"
        role="menu"
      >
        <button
          type="button"
          class="flex w-full gap-3 items-start text-left px-3 py-3 hover_bg-gray-50"
          role="menuitem"
          @click="selectSharePresentation"
        >
          <span class="flex w-9 h-9 shrink-0 items-center justify-center rounded-md border border-gray-200 bg-gray-50 text-gray-800">
            <FontAwesomeIcon icon="share-nodes" class="w-4 h-4" />
          </span>
          <span class="flex min-w-0 flex-1 flex-col gap-1 text-left">
            <span class="font-medium text-sm text-gray-900 leading-tight">Share Presentation</span>
            <span class="text-xs text-gray-500 font-normal leading-snug">Manage editors, viewers &amp; access</span>
          </span>
        </button>
        <button
          v-if="canManagePressRelease"
          type="button"
          class="flex w-full gap-3 items-start text-left px-3 py-3 hover_bg-gray-50"
          role="menuitem"
          @click="selectPressRelease"
        >
          <span class="flex w-9 h-9 shrink-0 items-center justify-center rounded-md border border-gray-200 bg-gray-50 text-gray-800">
            <FontAwesomeIcon icon="newspaper" class="w-4 h-4" />
          </span>
          <span class="flex min-w-0 flex-1 flex-col gap-1 text-left">
            <span class="font-medium text-sm text-gray-900 leading-tight">Press Release</span>
            <span class="text-xs text-gray-500 font-normal leading-snug">Create/Generate a shareable press release link</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'

defineProps<{
  canManagePressRelease: boolean
}>()

const emit = defineEmits<{
  'open-share': []
  'open-press-release': []
}>()

const rootRef = ref<HTMLElement | null>(null)
const menuOpen = ref(false)

function selectSharePresentation() {
  menuOpen.value = false
  emit('open-share')
}

function selectPressRelease() {
  menuOpen.value = false
  emit('open-press-release')
}

function closeOnClickAway(e: MouseEvent) {
  if (e.target !== rootRef.value && !rootRef.value?.contains(e.target as Node)) {
    menuOpen.value = false
  }
}

onMounted(() => document.addEventListener('click', closeOnClickAway))
onBeforeUnmount(() => document.removeEventListener('click', closeOnClickAway))
</script>
